var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isRequestsAvailable
    ? _c(
        "gg-card",
        [
          _c(
            "gg-card-header",
            [
              _vm._v(" My Data Requests "),
              _c(
                "gg-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    disabled: _vm.loading
                  },
                  on: {
                    click: _vm.loadData
                  }
                },
                [_c("v-icon", [_vm._v(" mdi-refresh ")])],
                1
              )
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "transition",
                {
                  attrs: {
                    name: "fade"
                  }
                },
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.requests,
                      loading: _vm.loading
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.actions",
                          fn: function fn(_ref) {
                            var item = _ref.item
                            return [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    disabled: item.download_available === 0
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.downloadRequest(item.id)
                                    }
                                  }
                                },
                                [_vm._v(" Download ")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2645809610
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }